import { useQuery } from '@tanstack/react-query';

import { taskCommentsQueryOptions } from './query-options';

export const useGetTaskCommentsQuery = (taskId: string) =>
    useQuery(taskCommentsQueryOptions.getTaskCommentsQueryOptions(taskId));
